// extracted by mini-css-extract-plugin
export default {"link":"TextLink_link__6PJKz","link__text":"TextLink_link__text__UwYae","link--hero":"TextLink_link--hero__8vWE0","link--bold":"TextLink_link--bold__mFf2c"};